import { Notification } from '@thanx/uikit/notification'
import { Select } from '@thanx/uikit/select'
import { useGetBrameCampaignsQuery } from 'api/brameCampaigns'
import hollowInfo from 'assets/images/hollowInfo.svg'
import icExternalLink from 'assets/images/ic-external-link.svg'
import { buildTranslate } from 'locales'
import { FormGroup, FormLabel } from 'react-bootstrap-five'
import { Link } from 'react-router-dom'

type BrameCampaignSelectorProps = {
  value: number | undefined
  onChange: (value: number | undefined) => void
  disabled?: boolean
}

const t = buildTranslate('cms.content.app_navigation.bottom_nav.brame_campaign')

const BrameCampaignSelector = ({
  value,
  onChange,
  disabled = false,
}: BrameCampaignSelectorProps) => {
  const { data: brameCampaigns = [], isLoading } = useGetBrameCampaignsQuery()

  const campaignOptions = brameCampaigns.map(campaign => ({
    value: campaign.id,
    label: campaign.name,
  }))

  const hasNoCampaigns = !isLoading && brameCampaigns.length === 0

  const handleChange = (selectedOptions: any[]) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      onChange(undefined)
    } else {
      const selectedValue = selectedOptions[0]?.value
      const numericValue =
        typeof selectedValue === 'string'
          ? parseInt(selectedValue, 10)
          : selectedValue
      onChange(numericValue)
    }
  }

  return (
    <FormGroup className="mb-l">
      <FormLabel className="body-text-4 bold mb-xs">{t('label')}</FormLabel>

      <Select
        value={
          value !== undefined
            ? campaignOptions.find(
                option => String(option.value) === String(value)
              )
            : undefined
        }
        placeholder={t('placeholder')}
        options={campaignOptions}
        isLoading={isLoading}
        disabled={disabled || hasNoCampaigns}
        onChange={handleChange}
        searchable={false}
      />

      {hasNoCampaigns && (
        <div className="mt-s">
          <Notification size="full" kind="info">
            <div className="d-flex align-items-start">
              <img
                src={hollowInfo}
                alt=""
                aria-hidden="true"
                className="mr-s"
              />
              <div className="body-text-4 grey-70-text">
                <div className="mb-s">{t('empty_state.message')}</div>
                <Link
                  to="/games"
                  className="text-decoration-none d-inline-flex align-items-center text-primary"
                >
                  <span className="mr-xs">{t('empty_state.link_text')}</span>
                  <img
                    src={icExternalLink}
                    alt=""
                    aria-hidden="true"
                    width="15"
                    height="15"
                  />
                </Link>
              </div>
            </div>
          </Notification>
        </div>
      )}
    </FormGroup>
  )
}

export default BrameCampaignSelector
